// extracted by mini-css-extract-plugin
export default {"wrapper":"shortlist_items-modules___wrapper___f579ae2a"};